var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, TextField, Typography } from "@mui/material";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { FormActions } from "../utils/FormActions";
import { PlayerMetadataFields } from "./PlayerMetadataFields";
/**
 * Shared form for creating and editing an offline (guest) player. Create and
 * update are the same fields with different defaults, submit handler, and
 * labels, so both flows render this.
 */
export var OfflinePlayerForm = function (_a) {
    var title = _a.title, submitLabel = _a.submitLabel, defaultValues = _a.defaultValues, _b = _a.showSquadNumber, showSquadNumber = _b === void 0 ? false : _b, isError = _a.isError, errorMessage = _a.errorMessage, footer = _a.footer, onSubmit = _a.onSubmit, onCancel = _a.onCancel;
    var _c = useForm({ defaultValues: defaultValues }), control = _c.control, handleSubmit = _c.handleSubmit, errors = _c.formState.errors;
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: isError, message: errorMessage }), _jsx(Typography, { variant: "h6", children: _jsx("strong", { children: title }) }), _jsxs(Box, { component: "form", role: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, sx: { mt: 1 }, children: [_jsx(Typography, { variant: "h6", children: "Personal Information" }), _jsx(Divider, { style: { margin: "15px 0" } }), _jsx(Controller, { name: "externalUser.firstName", control: control, rules: { required: "First Name is required" }, render: function (_a) {
                            var _b, _c, _d;
                            var field = _a.field;
                            return (_jsx(TextField, __assign({}, field, { margin: "normal", fullWidth: true, label: "First Name", required: true, error: !!((_b = errors.externalUser) === null || _b === void 0 ? void 0 : _b.firstName), helperText: (_d = (_c = errors.externalUser) === null || _c === void 0 ? void 0 : _c.firstName) === null || _d === void 0 ? void 0 : _d.message, autoFocus: true })));
                        } }), _jsx(Controller, { name: "externalUser.lastName", control: control, rules: { required: "Last Name is required" }, render: function (_a) {
                            var _b, _c, _d;
                            var field = _a.field;
                            return (_jsx(TextField, __assign({}, field, { margin: "normal", fullWidth: true, label: "Last Name", required: true, error: !!((_b = errors.externalUser) === null || _b === void 0 ? void 0 : _b.lastName), helperText: (_d = (_c = errors.externalUser) === null || _c === void 0 ? void 0 : _c.lastName) === null || _d === void 0 ? void 0 : _d.message })));
                        } }), showSquadNumber && (_jsx(Controller, { name: "squadNumber", control: control, rules: {
                            min: { value: 1, message: "Must be between 1 and 99" },
                            max: { value: 99, message: "Must be between 1 and 99" },
                        }, render: function (_a) {
                            var _b, _c, _d;
                            var field = _a.field;
                            return (_jsx(TextField, __assign({}, field, { value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                                    var val = e.target.value;
                                    field.onChange(val === "" ? null : Number(val));
                                }, margin: "normal", fullWidth: true, label: "Squad Number", type: "number", error: !!errors.squadNumber, helperText: (_d = (_c = errors.squadNumber) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : "Optional (1-99)", inputProps: { min: 1, max: 99 } })));
                        } })), _jsx(Typography, { variant: "h6", sx: { mt: 3 }, children: "Player Details" }), _jsx(PlayerMetadataFields, { control: control, namePrefix: "player." }), _jsx(FormActions, { submitLabel: submitLabel, onCancel: onCancel }), footer] })] }));
};
// Required fields start blank ("") so the user must consciously pick them.
export var DEFAULT_PLAYER_METADATA = {
    nationality: "",
    foot: "",
    positionOne: "",
    positionTwo: "",
    bio: "",
    heading: 50,
    passing: 50,
    positioning: 50,
    defending: 50,
    finishing: 50,
    dribbling: 50,
    shooting: 50,
    tackling: 50,
    crossing: 50,
    leadership: 50,
    communication: 50,
    speed: 50,
    fitness: 50,
    keeping: 50,
};
